module.exports = __webpack_public_path__ + "img/1.e39f5444.png";